/* sk8 Monster Drops, tema PS2, jogo.js.
   Dono: frente 5 (jogo). Abre e fecha o modal do LINHA em tela cheia (o
   botao "Jogo" mora no cabecalho/HUD de toda pagina, entao este arquivo
   tambem carrega em toda pagina) e anima a faixa widescreen da secao #jogo
   (a caveirinha rolando de um lado a outro sobre o cenario em paralaxe),
   so quando ela esta visivel. Depois de base.js (usa SK8.som, SK8.$,
   SK8.$$, SK8.jogo). Expoe SK8.fecharJogo para o Escape e o botao B do
   controle, tratados em base.js, fecharem o modal daqui. */
(function () {
  "use strict";

  var SK8 = window.SK8 || {};
  var $ = SK8.$, $$ = SK8.$$;
  var Som = SK8.som;

  /* ---------- modal do jogo ----------
     O foco vai para o botao "Sair do jogo", nao para o iframe: com o foco no
     iframe (outro dominio), o Esc ia para o jogo e o documento da loja nunca
     via a tecla. Assim o Esc fecha logo depois de abrir (base.js chama
     SK8.fecharJogo). Para jogar com teclado, basta tocar ou clicar no jogo,
     que ele recebe o foco. O jogo tambem pode pedir para fechar com
     postMessage({ tipo: "sk8:fechar-jogo" }), vindo do endereco do proprio jogo. */
  var modal = $("#modal-jogo");
  var origemJogo = null;
  function abrirJogo(url) {
    if (!modal) { location.href = url; return; }
    var f = $("iframe", modal);
    if (f && f.getAttribute("src") !== url) f.setAttribute("src", url);
    try { origemJogo = new URL(url, location.href).origin; } catch (e) { origemJogo = null; }
    modal.hidden = false;
    document.documentElement.style.overflow = "hidden";
    $$(".titulo video").forEach(function (v) { v.pause(); });
    Som.tocar("confirmar");
    var sair = $("[data-fechar-jogo]", modal);
    setTimeout(function () { if (sair) sair.focus({ preventScroll: true }); }, 60);
  }
  function fecharJogo() {
    if (!modal || modal.hidden) return;
    modal.hidden = true;
    document.documentElement.style.overflow = "";
    var f = $("iframe", modal);
    if (f) f.setAttribute("src", "about:blank");
    var b = $("[data-abrir-jogo]");
    if (b) b.focus({ preventScroll: true });
  }
  SK8.fecharJogo = fecharJogo;
  $$("[data-abrir-jogo]").forEach(function (b) {
    b.addEventListener("click", function (e) { e.preventDefault(); abrirJogo(b.getAttribute("data-abrir-jogo") || SK8.jogo); });
  });
  $$("[data-fechar-jogo]").forEach(function (b) { b.addEventListener("click", function () { Som.tocar("voltar"); fecharJogo(); }); });
  window.addEventListener("message", function (e) {
    if (!modal || modal.hidden || !origemJogo || e.origin !== origemJogo) return;
    var d = e.data;
    if (d === "sk8:fechar-jogo" || (d && (d.tipo === "sk8:fechar-jogo" || d.type === "sk8:fechar-jogo"))) { Som.tocar("voltar"); fecharJogo(); }
  });

  // ---------- faixa widescreen: caveirinha rolando + cenario em paralaxe ----------
  // A folha ja traz manobras (ollie, kickflip, heelflip, 360-flip) misturadas no
  // ciclo de "rolando". O movimento (a caveirinha indo de uma ponta a outra da
  // faixa e voltando, espelhada ao virar, e as camadas de fundo deslizando cada
  // uma na sua velocidade relativa: ceu parado, predios ao longe devagar,
  // predios perto mais rapido, chao na velocidade do personagem) e animacao de
  // CSS em transform (jogo.css), que o navegador faz sozinho, sem repintar a
  // cena a cada quadro. Aqui so: 1) medir a faixa util e passar para o CSS
  // (--util, e --passos para o deslocamento andar de pixel em pixel da tela,
  // como antes), 2) trocar o quadro da folha a 12 fps, 3) ligar e desligar tudo
  // conforme a faixa entra e sai da tela ou a aba fica escondida. Com "menos
  // movimento" fica o quadro inicial, parado.
  $$(".jogo-cena").forEach(function (cena) {
    var personagem = $(".jogo-personagem", cena);
    if (!personagem) return;
    var d = personagem.dataset;
    var w = +d.largura, h = +d.altura, n = +d.quadros, fps = +d.fps || 12, cols = +d.colunas;
    var camadas = $$(".jogo-camada", cena).map(function (el) {
      var vel = +el.dataset.velocidade || 0;
      if (vel) { el.style.setProperty("--vel", vel); el.setAttribute("data-movel", ""); }
      return { el: el, vel: vel };
    });
    var calmo = window.matchMedia && matchMedia("(prefers-reduced-motion: reduce)").matches;
    var q = 0, quadroTempo = null, escala = 0, naTela = false;
    // a folha de quadros fica num filho sem animacao: trocar o quadro so
    // recalcula esse filho, e nao o elemento que esta deslizando
    var folha = document.createElement("span");
    folha.className = "jogo-folha";
    folha.setAttribute("aria-hidden", "true");
    personagem.appendChild(folha);

    function desenharQuadro() {
      var x = (q % cols) * w * escala, y = Math.floor(q / cols) * h * escala;
      folha.style.backgroundPosition = (-x) + "px " + (-y) + "px";
    }
    // medidas lidas so quando a faixa muda de tamanho (ResizeObserver), nunca por quadro
    function medir() {
      var e = parseFloat(getComputedStyle(personagem).getPropertyValue("--escala-cena")) || 2;
      var dpr = window.devicePixelRatio || 1;
      // faixa util arredondada para um numero par de pixels da tela: cada passo
      // e o meio da faixa caem em pixel inteiro e a caveirinha nao borra
      var util = Math.max(0, Math.floor((cena.clientWidth - w * e) * dpr / 2) * 2 / dpr);
      cena.style.setProperty("--util", util + "px");
      cena.style.setProperty("--passos", Math.max(1, Math.round(util * dpr)));
      camadas.forEach(function (c) { if (c.vel) c.el.style.setProperty("--passos", Math.max(1, Math.round(util * c.vel * dpr))); });
      if (e !== escala) {
        escala = e;
        folha.style.backgroundImage = "url(\"" + d.folha + "\")";
        folha.style.backgroundSize = (cols * w * e) + "px " + (Math.ceil(n / cols) * h * e) + "px";
        desenharQuadro();
      }
    }
    function tocar() {
      if (calmo || !naTela || document.hidden) return parar();
      cena.classList.add("rodando");
      if (!quadroTempo) quadroTempo = setInterval(function () { q = (q + 1) % n; desenharQuadro(); }, 1000 / fps);
    }
    function parar() {
      cena.classList.remove("rodando");
      clearInterval(quadroTempo); quadroTempo = null;
    }

    if ("ResizeObserver" in window) new ResizeObserver(medir).observe(cena);
    else { medir(); window.addEventListener("resize", medir); }
    if ("IntersectionObserver" in window) new IntersectionObserver(function (es) { naTela = es[0].isIntersecting; tocar(); }, { threshold: .15 }).observe(cena);
    else { naTela = true; tocar(); }
    document.addEventListener("visibilitychange", tocar);
  });

  window.SK8 = SK8;
})();
